/**
 * Generated project cover for the grid tile. Delegates to the pure helpers in
 * lib/projectCover so the grid tile and list row render identical covers.
 *
 * If the project has a custom posterUrl, use it (real <img> with @error
 * falling back to the generated cover). Otherwise render the project's
 * initials on a per-project deterministic color.
 */
import { coverInitials, coverColor, hasPoster } from '@/lib/projectCover';

export default {
    data() {
        return {
            posterFailed: false
        };
    },
    computed: {
        coverInitials() {
            return coverInitials(this.project && this.project.title);
        },
        coverColor() {
            return coverColor(this.project && this.project.id);
        },
        hasPoster() {
            return hasPoster(this.project, this.posterFailed);
        }
    },
    methods: {
        onPosterError() {
            this.posterFailed = true;
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/projectCover.js